import React, { useCallback, useEffect, useState } from "react";
import App from "../App";
import api from "../api";
import { clearToken } from "../auth";

function DashboardPage() {
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");

  const logout = useCallback(() => {
    clearToken();
    // Hard redirect guarantees route change even with stale in-memory state.
    window.location.replace("/login");
  }, []);

  useEffect(() => {
    const fetchMe = async () => {
      try {
        const response = await api.get("/api/me");
        setUsername(response.data.username);
      } catch (requestError) {
        setError("Session expired. Please login again.");
        logout();
      }
    };
    fetchMe();
  }, [logout]);

  return (
    <div>
      <header
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "12px 16px",
          background: "linear-gradient(90deg, #172554 0%, #1e1b4b 100%)",
        }}
      >
        <h2 style={{ margin: 0, color: "#f8fafc", fontWeight: 700 }}>
          Welcome, {username || "User"}
        </h2>
        <button
          type="button"
          onClick={logout}
          style={{
            border: "1px solid #38bdf8",
            background: "transparent",
            color: "#e0f2fe",
            padding: "8px 14px",
            borderRadius: 8,
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          Logout
        </button>
      </header>
      {error && (
        <div style={{ color: "#b91c1c", margin: "0 12px 12px 12px" }} role="alert">
          {error}
        </div>
      )}
      <App />
    </div>
  );
}

export default DashboardPage;
